<template>
  <v-app class="application--is-rtl main-app" app-data="true">
    <!-- Section top navigation + sidebar mobile menu -->

    <NavBar />

    <Nuxt />
    <Footer class="footer-wrap" />
  </v-app>
</template>

<script>
import NavBar from '@/components/NavigationMenu/NavBar'
import Footer from '@/components/Footer/Footer'
import DeviceDetect from '@/components/mixins/DeviceDetect'
import BrazeUserSetup from '@/components/mixins/BrazeUserSetup';
// import recaptchaV3 from '@/components/mixins/recaptchaV3';

export default {
  name: 'defaultLayout',
  mixins: [DeviceDetect, BrazeUserSetup],
  components: {
    NavBar,
    Footer,

  },
}
</script>
